<template>
  <div class="main-view">
    <el-radio-group
      v-model="table.params.type"
      @change="handleTabs"
      style="margin-bottom: 10px"
    >
      <el-radio-button :label="1">待发放({{ table.total_1 }})</el-radio-button>
      <el-radio-button :label="2">已发放({{ table.total_2 }})</el-radio-button>
    </el-radio-group>
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" size="mini">
        <el-form-item label="收款人" prop="name">
          <el-input
            clearable
            v-model.trim="table.params.name"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input
            clearable
            v-model.trim="table.params.phone"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="工作单位" prop="work_company">
          <el-select v-model="table.params.work_company" placeholder="请选择" clearable filterable>
            <el-option
              v-for="item in companyOption"
              :key="item.company_name"
              :label="item.company_name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发放单位" prop="company_name">
          <el-input
            clearable
            v-model.trim="table.params.company_name"
            placeholder="请输入"
            @clear="onSearch"
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="theneBtn"
            type="primary"
            icon="el-icon-search"
            @click="onSearch"
            >查询
          </el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <div style="display: flex; align-items: center; gap: 10px">
        <el-button type="primary" size="mini" @click="toRecharge"
          >发放报酬</el-button
        >
        <el-button
          v-if="table.params.type == 1"
          type="primary"
          size="mini"
          @click="batchRecharge"
          >批量导入</el-button
        >
        <el-button
          v-if="table.params.type == 1"
          type="primary"
          size="mini"
          @click="batchConfirm"
          >批量确认</el-button
        >
        <div>
          <span style="margin-right: 10px"
            >累计充值￥{{ table.total_amount }}</span
          >
          <span style="margin-right: 10px"
            >已发放￥{{ table.yet_send_amount }}</span
          >
          <span style="margin-right: 10px"
            >待发放￥{{ table.await_send_amount }}
          </span>
          <span>剩余可用￥{{ table.surplus_amount }}</span>
          <span @click="viewDetail" style="color:#999;cursor: pointer;font-size: 14px;
    margin-left: 10px;">查看详情</span>
        </div>
      </div>
    </div>

    <div class="curTableWrap" ref="main">
      <el-table
        :data="table.data"
        ref="tableDom"
        :height="tableHeight"
        :key="table.params.type"
        border
        style="width: 100%"
        v-loading="table.loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0)"
        :header-cell-style="{ background: '#f5f5f5' }"
        class="chTable"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          v-if="table.params.type == 1"
        >
        </el-table-column>
        <el-table-column label="序号" type="index" width="60">
        </el-table-column>
        <el-table-column label="收款人" prop="name" min-width="100">
        </el-table-column>
        <el-table-column label="手机号" prop="phone" min-width="100">
        </el-table-column>
        <el-table-column label="结算开始日" prop="start_time" min-width="100">
        </el-table-column>
        <el-table-column label="结算截止日" prop="end_time" min-width="100">
        </el-table-column>
        <el-table-column label="共计工时/小时" prop="hour" min-width="100">
        </el-table-column>
        <el-table-column label="结算金额" prop="amount" min-width="100">
          <template slot-scope="{ row }">￥{{ row.amount }}</template>
        </el-table-column>
        <el-table-column label="工作单位" prop="work_company_name" min-width="120">
        </el-table-column>
        <el-table-column label="发放单位" prop="company_name" min-width="120">
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="create_time"
          show-overflow-tooltip
          min-width="130"
        >
          <template slot-scope="{ row }">
            <div>{{ row.create_time }}</div>
            <div>{{ row.create_name }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-if="table.params.type == 2"
          label="发放时间"
          prop="send_time"
          show-overflow-tooltip
          min-width="130"
        >
          <template slot-scope="{ row }">
            <div>{{ row.send_time }}</div>
            <div>{{ row.send_name }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="action" fixed="right" width="160">
          <template slot-scope="{ row }">
            <el-popconfirm
              v-if="table.params.type == 1"
              title="确认发放吗？"
              @confirm="reviewRow(row)"
              style="margin-right: 6px"
            >
              <el-button slot="reference" type="text">确认发放</el-button>
            </el-popconfirm>
            <el-button
              
              v-if="table.params.type == 1"
              type="text"
              @click="toRecharge(row)"
              >编辑</el-button
            >
            <el-popconfirm
              v-if="table.params.type == 1"
              title="确认删除吗？"
              @confirm="toDelete(row)"
              style="margin-left: 6px"
            >
              <el-button slot="reference" type="text">删除</el-button>
            </el-popconfirm>
            <el-button v-if="table.params.type == 2" type="text" @click="reviewRowAgain(row)">再次申请</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination__wrap">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="table.params.page"
          :page-size="table.params.count"
          :total="table.total"
          :page-sizes="[10, 20, 50, 100, 150]"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <payDialog ref="rechargeDialogRef" @success="getTable"></payDialog>
    <payAgainDialog ref="payAgainDialogRef" @success="getTable"></payAgainDialog>
    <importDailog ref="importDailogRef" @refresh="getTable"></importDailog>
    <amountDailog ref="amountDailogRef" @refresh="getTable"></amountDailog>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import { mixinTableHeight } from "@/mixins/tableHeight.js";
import payDialog from "./components/payDialog.vue";
import payAgainDialog from "./components/payAgainDialog.vue";
import importDailog from "./components/importDailog.vue";
import amountDailog from "./components/amountDailog.vue"
export default {
  components: {
    VTable,
    payDialog,
    payAgainDialog,
    importDailog,
    amountDailog
  },
  mixins: [mixinTable, mixinTableHeight],
  data() {
    return {
      table: {
        loading: false,
        params: {
          type: 1,
          company_name: "",
          work_company: "",
          phone: "",
          name: "",
          date: [],
          page: 1,
          count: 10,
        },
        data: [],
        total_1: 0,
        total_2: 0,
        total: 0,
        total_amount: 0,
        yet_send_amount: 0,
        await_send_amount: 0,
        surplus_amount: 0,
      },
      payInfo: {},
      multipleSelection: [],
      file: "",
    };
  },
  created() {
    this.getCompanyOption();
    this.getTable();
  },
  methods: {
    getCompanyOption() {
      this.$http
        .get("/admin/flex_salary/company",{ params: {} }).then(res =>{
          if(res.code == 1){
            this.companyOption = res.data.list;
          }
        })
    },
    viewDetail() {
      let dom = this.$refs.amountDailogRef;
      dom.toggle(true);
      dom.getDetail();
    },
    getTable() {
      console.log(this.table.params, "this.table.params");
      let _params = { ...this.table.params };
      this.$http
        .get("/admin/flex_send/list", { params: _params })
        .then((res) => {
          if (res.code === 1) {
            this.multipleSelection = [];
            this.file = res.data.file;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.table.total_1 = res.data.total_1;
            this.table.total_2 = res.data.total_2;
            this.table.total_amount = res.data.total_amount;
            this.table.yet_send_amount = res.data.yet_send_amount;
            this.table.await_send_amount = res.data.await_send_amount;
            this.table.surplus_amount = res.data.surplus_amount;
            this.payInfo = {
              bank: res.data.bank,
              weChat: {
                ...res.data.weChat,
                // code_url:
                //   "https://qn.cdn.jszhr.com/wisdom/20260414/c22865b0c4d49734dfc4a5dbbc91b3c5.jpeg",
              },
            };
            this.$nextTick(() => {
              this.$refs.tableDom.doLayout();
            });
          }
        });
    },
    // 我要充值
    toRecharge(row) {
      let dom = this.$refs.rechargeDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    batchConfirm() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请选择数据");
        return;
      }
      let amount = this.multipleSelection.reduce((total, item) => {
        return total + Number(item.amount);
      }, 0);
      let showAmount = amount.toFixed(2);
      let str = `已选择${this.multipleSelection.length}条数据  ￥${showAmount}，确定要发放吗？`;
      this.$confirm(str, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = this.multipleSelection.map((item) => item.id).join(",");
        this.$http
          .post("/admin/flex_send/patchSend", { ids: ids })
          .then((res) => {
            if (res.code === 1) {
              if(res.data.error && res.data.error.length){
                // 用 <br> 分割，开启html解析
              const errList = res.data.error.join('<br>')
              const alertMsg = `以下姓名电话号码与用户认证信息不一致，请重新确认！<br><br>${errList}`
              this.$alert(alertMsg, '校验提示', {
                confirmButtonText: '知道了',
                dangerouslyUseHTMLString: true // ✅关键！允许解析html标签
              })
              }else {
                this.$message.success("操作成功");
              }
              this.getTable();
            }
          });
      });
    },
    reviewRow(row) {
      this.$http.post("/admin/flex_send/send", { id: row.id }).then((res) => {
        if (res.code === 1) {
          this.$message.success("操作成功");
          this.getTable();
        }
      });
    },
    toDelete(row) {
      this.$http.post("/admin/flex_send/delete", { id: row.id }).then((res) => {
        if (res.code === 1) {
          this.$message.success("操作成功");
          this.getTable();
        }
      });
    },
    reviewRowAgain(row) {
      let dom = this.$refs.payAgainDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchRecharge() {
      let dom = this.$refs.importDailogRef;
      dom.toggle(true);
      dom.getDetail(this.file);
      dom = null;
    },
  },
};
</script>
<style scoped lang="scss">
.curTableWrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0 24px;
  background: #fff;
  flex: 1;
  overflow: hidden;
}
.pagination__wrap {
  margin: 10px 0;
  text-align: right;
  padding-right: 40px;
}
</style>